import $ from 'jquery'
import _ from 'underscore'
import Backbone from 'backbone'
import ClassViewTemplate from '../templates/class.tpl'
import TextTemplate from '../templates/text.tpl'
import Request from '../helpers/request'
import NoUserView from './no-user'
import UserModel from '../models/user'
import UserReportingView from './user-reporting'
import UserView from './user'
import EditClassView from './edit-class'

const ClassView = Backbone.View.extend({
    tagName: 'li',
    id: 'class-view',
    events: {
        'click .open': 'toggleClass',
        'click .edit': 'editClass',
    },
    open: false,
    reporting: false,
    initialize() {
        this.template = _.template(ClassViewTemplate)
        this.textTemplate = _.template(TextTemplate)
        this.listenTo(this.model, 'change', this.render)
        this.listenTo(this.model, 'destroy', this.remove)
    },
    render() {
        this.$el.html(this.template(this.model.toJSON()))
        return this
    },
    toggleClass() {
        if (this.open) {
            this.$('.open').html(this.textTemplate({text: 'Open'}))
            this.$('.class-user-list').html(this.textTemplate({text: ''}))
        } else {
            this.$('.open').html(this.textTemplate({text: 'Close'}))
            Request({
                url: '/api/school/class/' + this.model.get('id') + '/student',
                method: 'GET',
                data: {
                    sort: 'firstnameLowercase lastnameLowercase',
                    limit: 500,
                },
            })
                .then((response) => this.listStudents(response))
        }

        this.open = !this.open
    },
    listStudents(response) {
        if (response.students.length === 0) {
            const noUserView = new NoUserView()
            this.$('.class-user-list').append(noUserView.render().el)
        } else {
            _.each(response.students, (userItem) => {
                // set the user details
                const userModel = new UserModel({
                    id: userItem._id,
                    firstname: userItem.firstname,
                    lastname: userItem.lastname,
                    username: userItem.username,
                    purchased: userItem.appIds,
                })

                // set the type
                if (userItem.type) {
                    userModel.get('type').set('name', userItem.type)
                }

                // set the class
                if (userItem.type) {
                    userModel.get('class').set('id', userItem.classId)
                }

                let userView = null

                if (this.reporting) {
                    userView = new UserReportingView({model: userModel})
                } else {
                    userView = new UserView({model: userModel})
                }

                this.$('.class-user-list').append(userView.render().el)
            })
        }
    },
    editClass() {
        const editClassView = new EditClassView({model: this.model})
        $('#form-wrapper').html(editClassView.render().el)
    },
})

export default ClassView